import * as React from "react";
import i18n from "i18n";
import StreamFailureCountCell from "./StreamFailureCountCell";
export const FAILURE_COUNT_ATTRIBUTE_NAME = "failure_count";
const streamFailureColumn = {
  attributeName: FAILURE_COUNT_ATTRIBUTE_NAME,
  group: "performance",
  attributes: [
    {
      id: FAILURE_COUNT_ATTRIBUTE_NAME,
      // Read lazily, so the title is translated when the table renders and not when the module loads.
      get title() {
        return i18n.t("stream_failure_column.title", { ns: "enterprise_data_tiering" });
      },
      type: "INT"
    }
  ],
  columnRenderers: {
    [FAILURE_COUNT_ATTRIBUTE_NAME]: {
      renderCell: (_value, stream) => /* @__PURE__ */ React.createElement(StreamFailureCountCell, { stream }),
      staticWidth: 180
    }
  },
  metricFields: {
    [FAILURE_COUNT_ATTRIBUTE_NAME]: [FAILURE_COUNT_ATTRIBUTE_NAME]
  }
};
export default streamFailureColumn;
